import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react';
import { formatGraphqlErrors } from 'utils/helpers';
import { AllAdminsDocument, DeleteAdminDocument } from 'graphql/generated/graphql';

const useUnassignAdmin = () => {
  const [unassignAdminMutation] = useMutation(DeleteAdminDocument);

  const handleUnassign = useCallback(
    async (email: { email: string }) => {
      try {
        await unassignAdminMutation({
          variables: email,
          refetchQueries: [{ query: AllAdminsDocument }],
          awaitRefetchQueries: true,
        });
      } catch (error) {
        throw formatGraphqlErrors(error);
      }
    },
    [unassignAdminMutation],
  );
  return handleUnassign;
};

export default useUnassignAdmin;
